import { OnInit, OnDestroy } from '@angular/core';
import { BdGraph } from 'src/lib/graph/graph.model';
import { ViewTreeNode } from 'src/app/engine/models/view.tree-node';
import { BdGraphService } from 'src/lib/graph/graph.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { Store } from '@ngxs/store';
import { takeUntil } from 'rxjs/operators';
import { CollapseNode, ExpandNode } from 'src/app/engine/state/nodes/engine.nodes.actions';
import { TreeTheme } from '../tree/tree.component';
import { GraphUtils } from 'src/lib/graph/graph-utils';
var TreeGroupComponent = /** @class */ (function () {
    function TreeGroupComponent(graphService, store) {
        this.graphService = graphService;
        this.store = store;
        this.treeTheme = TreeTheme;
        this.graphSubject = new BehaviorSubject(null);
        this.theme = TreeTheme.Dark;
        this.nodes = [];
        this.ngUnsubscribe = new Subject();
    }
    Object.defineProperty(TreeGroupComponent.prototype, "graph", {
        get: function () {
            return this._graph;
        },
        set: function (value) {
            if (!value) {
                return;
            }
            this._graph = value;
            this.graphSubject.next(value);
        },
        enumerable: true,
        configurable: true
    });
    TreeGroupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.graphSubject
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (graph) {
            if (!graph) {
                return;
            }
            _this.getNodes();
        });
    };
    TreeGroupComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    TreeGroupComponent.prototype.getNodes = function () {
        var nodeIds = (this.node) ?
            GraphUtils.getSuccessors(this.graph, this.node.id) :
            GraphUtils.getRoots(this.graph);
        this.nodes = this.graphService.getNodes(this.graph, nodeIds);
    };
    TreeGroupComponent.prototype.countChildren = function (node) {
        return GraphUtils.getSuccessors(this.graph, node.id).length;
    };
    TreeGroupComponent.prototype.hasChildren = function (node) {
        return this.countChildren(node) > 0;
    };
    TreeGroupComponent.prototype.trackTreeNode = function (node) {
        return node.id;
    };
    TreeGroupComponent.prototype.handleExpandClick = function (node, expanded) {
        (expanded) ?
            this.store.dispatch(new CollapseNode(node)) :
            this.store.dispatch(new ExpandNode(node));
    };
    return TreeGroupComponent;
}());
export { TreeGroupComponent };
